import React from "react";
import { Link } from "react-router-dom";
import { Api } from "../app-controller.js";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import ProductClient from "../components/products/ProductClient";
import classnames from "classnames";

class ProductsClient extends React.Component {
  initialState = {
    previa: false,
    previa_url: "",
    nivelUsuario: localStorage.nivel_actual,
    modalState: false,
    modalInfoState: false,
    working: true,
    workingModal: true,
    toggle: false,
    paginaActual: 0,
    paginas: 0,
    registros: 0,
    productos: [],
    cat_estatus_producto: Api.loadCatalogue("cat_estatus_producto"),
    cat_tipo_producto: Api.loadCatalogue("cat_tipo_producto"),
    activeTab: "1",
    buscar: {},
    producto: {
      id: "",
      nombre_comercial: "",
      precauciones_generales: "",
      caducidad_producto: "",
      medida_tiempo: "",
      forma_farmaceutica: "",
      pais: "",
      uso: "",
      validez_preparacion: "",
      fabricante: "",
      titular: "",
      tipo_ingrediente_id: "",
      producto_ingrediente: "",
      clasificacion: "",
      categorizacion_oficial: "",
      tomo: "",
      folio: "",
      no_registro: "",
      dossier: "",
      principio_activo: [],
      excipiente: [],
      composicion_bilogica: [],
      composicion_quimica: [],
      dosis: [],
      envase: [],
      descarte: [],
      modo_empleo: [],
      componente: [],
      especieInteres: [],
      presentacion: [],
      regentes: [],
    },
    collapse: [
      {
        id: 1,
        collapse: true,
      },
      {
        id: 2,
        collapse: false,
      },
    ],
  };

  constructor(props) {
    super(props);

    this.state = this.initialState;

    this.handleSearch = this.handleSearch.bind(this);
    this.getProductsClient = this.getProductsClient.bind(this);
    this.handleListaProductosCliente =
      this.handleListaProductosCliente.bind(this);
    this.openModalProductClient = this.openModalProductClient.bind(this);
    this.handleModalCloseBtn = this.handleModalCloseBtn.bind(this);
    this.resetStates = this.resetStates.bind(this);
  }

  toggleTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  };

  toggleCollapse = (index) => {
    var newArray = [];
    for (let collapseObj of this.state.collapse) {
      if (collapseObj.id === index) {
        collapseObj.collapse = !collapseObj.collapse;
      } else {
        collapseObj.collapse = false;
      }
      newArray.push(collapseObj);
    }

    this.setState({ collapse: newArray });
  };

  componentDidMount() {
    // si el usuario no es nivel cliente redireccionamos a home
    if (this.state.nivelUsuario !== "1") {
      window.location.href = "/";
    }

    this.setState({ buscar: this.search });
    this.getProductsClient(1);
  }

  // Inicia logica que controla la pestaña de regente (grid y detalle)
  search = [];

  handleSearch(evt) {
    // Si el obj.target.name pertenece a un input type text aplicamos la funcion toUpperCase()
    [
      "nombre_comercial",
      "no_registro",
      "tipo_producto",
      "estatus",
      "vigencia_registro",
    ].includes(evt.target.name)
      ? (this.search[evt.target.name] = evt.target.value.toUpperCase())
      : (this.search[evt.target.name] = evt.target.value);

    this.setState({ buscar: this.search });
  }

  //Funcion para cambiar de pagina en el grid de regente
  getProductsClient(page) {
    this.setState({ workingGrid: true });
    let search = this.state.buscar;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch("app/getProductsClient?page=" + page + src).then((p) => {
      this.setState({
        productos: p.data,
        paginas: p.last_page,
        registros: p.total,
        paginaActual: p.current_page,
        workingGrid: false,
      });
    });
  }

  handleListaProductosCliente(e) {
    this.getProductsClient(e.target.value);
  }

  handleModalCloseBtn(evt) {
    evt.preventDefault();

    this.setState({
      workingModal: true,
      producto: this.initialState.producto,
      modalState: false,
      modalInfoState: false,
    });
  }

  openModalProductClient(evt) {
    this.setState({ modalInfoState: true, workingModal: true });
    //info producto
    Api.fetch("app/getProductClientInfo?producto_id=" + evt.target.id)
      .then((data) => {
        if (data) {
          this.setState({ producto: data });
        }
      })
      .then((res) => {
        this.setState({ workingModal: false });
      });
  }

  // fn para reiniciar todos los estados una vez el submit sea éxitoso
  resetStates() {
    this.setState({
      bitacora_producto: this.initialState.bitacora_producto,
      cantidades_lotes: [],
      observaciones: this.initialState.observaciones,
    });
  }

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/">Inicio</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/productos/activos">Productos</Link>
          </li>
          <li className="breadcrumb-item">Activos</li>
        </ol>
        <h1 className="page-header">Productos</h1>
        <div className="row">
          <div className="col-xl-12">
            <Nav tabs={true}>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.activeTab === "1",
                  })}
                  onClick={() => {
                    this.toggleTab("1");
                  }}
                >
                  <span className="d-sm-none">
                    PRODUCTOS
                    <span className="label label-success m-l-5 t-minus-1">
                      {this.state.registros}
                    </span>
                  </span>
                  <span className="d-sm-block d-none">
                    PRODUCTOS
                    <span className="label label-success m-l-5 t-minus-1">
                      {this.state.registros}
                    </span>
                  </span>
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId="1">
                <div className="table-responsive">
                  <fieldset>
                    <legend>Buscar</legend>

                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label htmlFor="nombre_comercial">
                            Nombre comercial:
                          </label>
                          <div className="form-group">
                            <input
                              id="nombre_comercial"
                              name="nombre_comercial"
                              onChange={this.handleSearch}
                              placeholder="Ingrese nombre comercial"
                              className="form-control"
                              type="text"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label htmlFor="no_registro">
                            Número de registro:
                          </label>
                          <input
                            id="no_registro"
                            name="no_registro"
                            placeholder="Ingrese número de registro"
                            onChange={this.handleSearch}
                            className="form-control"
                            type="text"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label htmlFor="tipo_producto">
                            Tipo de producto:
                          </label>
                          <select
                            name="tipo_producto"
                            id="tipo_producto"
                            className="form-control"
                            onChange={this.handleSearch}
                          >
                            <option value="">Seleccione</option>
                            {this.state.cat_tipo_producto.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.descripcion}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="form-group">
                          <label htmlFor="estatus">Estatus:</label>
                          <select
                            name="estatus"
                            id="estatus"
                            className="form-control"
                            onChange={this.handleSearch}
                          >
                            <option value="">Seleccione</option>
                            {this.state.cat_estatus_producto.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.descripcion}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="form-group">
                          <label htmlFor="vigencia_registro">
                            Vigencia registro:
                          </label>
                          <input
                            id="vigencia_registro"
                            name="vigencia_registro"
                            onChange={this.handleSearch}
                            className="form-control"
                            type="date"
                          />
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="form-group">
                          <label htmlFor="search">&nbsp;</label>
                          <button
                            type="button"
                            className="btn btn-orange w-100"
                            title="Buscar"
                            onClick={() => this.getProductsClient(1)}
                          >
                            <i className="fa fa-search"></i> Buscar
                          </button>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <table className="table table-striped m-b-0 table-hover">
                    <thead>
                      <tr>
                        <th className="text-center">NOMBRE COMERCIAL</th>
                        <th className="text-center">NÚMERO REGISTRO</th>
                        <th className="text-center">TIPO PRODUCTO</th>
                        <th className="text-center">VIGENCIA REGISTRO</th>
                        <th className="text-center">ESTADO</th>
                        <th className="text-center"></th>
                      </tr>
                    </thead>
                    <tbody className={this.state.workingGrid ? "hide" : ""}>
                      {this.state.productos &&
                      this.state.productos.length > 0 ? (
                        this.state.productos.map((p) => (
                          <tr key={p.id}>
                            <td className="text-center">
                              {p.nombre_comercial}
                            </td>
                            <td className="text-center">{p.no_registro}</td>
                            <td className="text-center">{p.tipo_producto}</td>
                            <td className="text-center">
                              {p.vigencia_registro}
                            </td>
                            <td className="text-center">
                              {p.estatus_producto}
                            </td>
                            <td className="text-center">
                              <div className="btn-group">
                                <button
                                  onClick={this.openModalProductClient}
                                  id={p.id}
                                  title="Ver información del producto"
                                  className="btn bg-gradient-blue"
                                >
                                  <i id={p.id} className="fas fa-eye"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center">
                            No se encontraron resultados
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <div className={this.state.workingGrid ? "m-10" : "hide"}>
                    <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                      CARGANDO INFORMACIÓN
                    </div>
                  </div>
                  <hr />
                  <div className="d-flex align-items-center justify-content-center">
                    <ul className="pagination mb-0">
                      <li className="page-item">
                        <button
                          onClick={() => {
                            this.getProductsClient(1);
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-double-left"></i>
                        </button>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            if (this.state.paginaActual - 1 > 0) {
                              this.getProductsClient(
                                this.state.paginaActual - 1
                              );
                            }
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-left"></i>
                        </button>
                      </li>
                      <li className="page-item d-flex align-items-center px-2">
                        <div>
                          Página
                          <strong>
                            {" "}
                            {this.state.paginaActual} de {this.state.paginas}
                          </strong>
                        </div>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            if (
                              this.state.paginas >=
                              this.state.paginaActual + 1
                            ) {
                              this.getProductsClient(
                                this.state.paginaActual + 1
                              );
                            }
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-right"></i>
                        </button>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            this.getProductsClient(this.state.paginas);
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-double-right"></i>
                        </button>
                      </li>
                    </ul>
                    <div className="ml-3 mr-1">Página:</div>
                    <div className="width-50 mx-2">
                      <input
                        className="form-control"
                        onChange={this.handleListaProductosCliente}
                        type="number"
                        min="1"
                        max={this.state.paginas}
                        value={this.state.paginaActual}
                      />
                    </div>
                    <div></div>
                  </div>
                </div>
              </TabPane>
            </TabContent>
          </div>

          <Modal
            isOpen={this.state.modalInfoState}
            tabIndex="-1"
            style={{
              maxWidth: "100%",
              width: "85%",
            }}
          >
            <ModalHeader
              width="100%"
              toggle={this.handleModalCloseBtn}
              className="text-center"
            >
              {this.state.producto
                ? `Producto: ${this.state.producto.nombre_comercial}`
                : null}
            </ModalHeader>
            <ModalBody>
              <ProductClient
                workingModal={this.state.workingModal}
                producto={this.state.producto}
                handleModalCloseBtn={this.handleModalCloseBtn}
              />
            </ModalBody>
          </Modal>
          <div className={this.state.previa ? "previa" : "hide"}>
            <iframe
              title="Vista previa"
              className="rounded"
              src={this.state.previa_url}
            ></iframe>
            <center>
              <div className="btn-group">
                <button
                  onClick={() => {
                    this.setState({
                      previa: this.initialState.previa,
                      previa_url: this.initialState.previa_url,
                    });
                  }}
                  className="btn btn-danger"
                >
                  Regresar
                </button>
                <a
                  className="btn btn-primary"
                  href={this.state.previa_url + "&download=1"}
                  download="download"
                >
                  Descargar
                </a>
              </div>
            </center>
          </div>
        </div>
      </div>
    );
  }
}

export default ProductsClient;
